import { createApi } from './core';
import { ServiceOffering } from './services.types';

declare const healConfig: any;

function createServicesApi() {
  return createApi({ baseURL: healConfig.apiBaseUrl + '/admin' });
}

function filterObsoleteServices(services: ServiceOffering[]) {
  return services.filter((s) => ['TDAP_ADULT', 'INJURED_ADULT', 'INJURED_CHILD', 'PED', 'TELEMEDICINE', 'LACTN_CNSLT', 'PCP'].indexOf(s.code) === -1);
}

export function fetchServices(): Promise<ServiceOffering[]> {
  return createServicesApi()
    .then((api) => api.get<any>('/services'))
    .then((r) => (r.ok ? r.data.data : []))
    .then((r) => filterObsoleteServices(r));
}
